export default function () {
    return {
        selection: [],
    }
}
